import { queryOptions } from '@tanstack/react-query';
import { getAdjusterRankpositionFunction } from './getAdjusterRankpositionQueryFunction';

export const getAdjusterRankpositionQueryOptions = () => {
  return queryOptions({
    queryKey: ['AdjusterRankPosition'],
    queryFn: () => getAdjusterRankpositionFunction(),
  });
};
